import {
  Backdrop,
  Box,
  Button,
  Fade,
  Grid,
  LinearProgress,
  makeStyles,
  Modal,
  Typography,
} from "@material-ui/core";
import plusImage from "images/plusrounded.svg";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch } from "react-redux";
import { postActivity } from "slices/activitySlice";
import { getFolder, notifyFileUploaded, UpdateFolder, UploadFiles } from "./FileApi";
import { MAX_UPLOAD_SIZE_BYTES, MAX_UPLOAD_SIZE_LABEL } from "./DocMgmtApi";
import { useSnackbar } from "contexts/SnackbarContext";

import Tabs from "features/Tabs/Tabs";

async function myCustomFileGetter(event) {
  const files = [];
  const fileList = event.dataTransfer
    ? event.dataTransfer.files
    : event.target.files;

  for (var i = 0; i < fileList.length; i++) {
    const file = fileList.item(i);
    files.push(file);
  }
  return files;
}

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "80%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    outline: "none",
    borderRadius: "0.4rem",
    overflowY: "auto",
    position: "absolute",
    left: "50%",
    top: "50%",
    "-webkit-transform": "translate(-50%, -50%)",
    transform: "translate(-50%, -50%)",
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
    },
  },
  firstText: {
    fontSize: "18px",
    // fontWeight: "400",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    color: TEXT.strong,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },
  selected: {
    background: "#F2F2F2",
    padding: "0.3rem 1.3rem",
  },
  unselected: {
    padding: "0.3rem 1.3rem",
    cursor: "pointer",
  },
  choiceText: {
    fontSize: "18px",
    fontWeight: "400",
    fontFamily: `'Inter',sans-serif`,
    color: TEXT.secondary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },
  fieldsText: {
    fontSize: "18px",
    fontWeight: "400",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    color: TEXT.strong,
    marginTop: "0.7rem",
    [theme.breakpoints.down("sm")]: {
      marginTop: "0.3rem",
      fontSize: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },
  inputfield: {
    width: "100%",
    height: "3rem",
    background: "#E0E0E0",
    color: TEXT.strong,
    fontSize: "18px",
    fontFamily: `'Inter',sans-serif`,
    border: "1px solid #E0E0E0",
    borderRadius: "4px",
    "&:focus": {
      outline: "none !important",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },
  inputfieldSebi: {
    width: "calc(100% - 10px)",
    height: "3rem",
    color: TEXT.strong,
    fontSize: "1rem",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    border: "2px solid #E0E0E0",
    paddingLeft: "10px",
    "&:focus": {
      outline: "none !important",
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
  dropbox: {
    width: "100%",
    background: "#E0E0E0",
    color: TEXT.strong,
    fontSize: "18px",
    fontFamily: `'Inter',sans-serif`,
    border: "1px solid #E0E0E0",
    borderRadius: "4px",
    padding: "1rem 2px",
    textAlign: "center",
    maxHeight: "50vh",
    overflow: "auto",
  },
  dropboxSebi: {
    width: "100%",
    background: "rgba(74, 59, 255, 0.03)",
    color: TEXT.strong,
    fontSize: "1rem",
    border: `2px dashed ${theme.palette.primary.main}`,
    padding: "1rem 2px",
    textAlign: "center",
    maxHeight: "30vh",
    overflow: "auto",
  },
  cancel: {
    textDecoration: "underline",
    fontSize: "20px",
    fontWeight: "400",
    color: TEXT.info,
    lineHeight: "36px",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      lineHeight: "26px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
      lineHeight: "26px",
    },
  },
  add: {
    fontSize: "20px",
    fontWeight: "400",
    color: TEXT.onDark,
    lineHeight: "36px",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      lineHeight: "26px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "16px",
      lineHeight: "26px",
    },
  },
  addbtn: {
    background: "#2F80ED",
    marginLeft: "3rem",
    width: "120px",
    padding: "0",
    [theme.breakpoints.down("sm")]: {
      width: "100px",
      marginLeft: "2rem",
    },
    [theme.breakpoints.down("xs")]: {
      width: "90px",
      marginLeft: "1rem",
    },
  },
  permissionsTable: {
    fontSize: "18px",
    fontWeight: "400",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    color: "black",
    wordBreak: "break-word",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },
  permissionsTableRows: {
    fontSize: "14px",
    fontWeight: "500",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    color: "black",
    wordBreak: "break-word",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
  box: {
    padding: "0.6rem 1rem",
    [theme.breakpoints.down("xs")]: {
      padding: "0.3rem 0.5rem",
    },
  },
  scroll: {
    overflowY: "auto",
    maxHeight: "20rem",
    cursor: "all-scroll",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "15rem",
    },
  },
}));

export default function UploadFile({
  openmodal,
  handleCloseModal,
  disputeId,
  folder_id,
  allProfiles,
  handleCloseModalRefresh,
  parent_folder,
  profile,
  isHidePermissionsFeature = false,
  customDisputeId,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const [choice, setChoice] = useState("details");

  const [loading, setLoading] = useState(false);
  const [uploadingFileName, setUploadingFileName] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const { acceptedFiles, rejectedFiles, getRootProps, getInputProps } = useDropzone({
    getFilesFromEvent: (event) => myCustomFileGetter(event),
    maxSize: MAX_UPLOAD_SIZE_BYTES,
  });
  const [filesPreview, setFilesPreview] = useState(false);
  useEffect(() => {
    if (acceptedFiles.length > 0) {
      setFilesPreview(true);
    }
  }, [acceptedFiles]);

  useEffect(() => {
    if (!rejectedFiles || rejectedFiles.length === 0) return;
    const names = rejectedFiles.map((file) => file.name).join(", ");
    showSnackbar(
      `Not added — exceeds the ${MAX_UPLOAD_SIZE_LABEL} per-file limit: ${names}`,
      "error"
    );
  }, [rejectedFiles]);

  const [viewPermissions, setViewPermissions] = useState(
    parent_folder ? parent_folder.view_permission || [] : []
  );
  const [deletePermissions, setdeletePermissions] = useState(
    parent_folder ? parent_folder.edit_permission || [] : []
  );

  const updatePermissionParentFolder = (parent) => {
    let prevViewPermissions = parent.view_permission || [];
    let prevDeletePermissions = parent.edit_permission || [];
    viewPermissions.forEach((element) => {
      if (prevViewPermissions.indexOf(element) === -1) {
        prevViewPermissions.push(element);
      }
    });
    deletePermissions.forEach((element) => {
      if (prevDeletePermissions.indexOf(element) === -1) {
        prevDeletePermissions.push(element);
      }
    });
    UpdateFolder(parent.id, {
      view_permission: prevViewPermissions,
      // edit_permission: prevDeletePermissions,
    });
    if (parent.parent_folder) {
      getFolder(parent.parent_folder.id).then((response) => {
        updatePermissionParentFolder(response.data[0]);
      });
    }
  };

  function arrayEquals(a, b) {
    return (
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index])
    );
  }

  const handleUploadFile = async () => {
    setLoading(true);
    setUploadProgress(0);
    try {
      if (parent_folder) {
        if (
          arrayEquals(parent_folder.view_permission, viewPermissions) &&
          arrayEquals(parent_folder.edit_permission, deletePermissions)
        ) {
          // no need to change folder permissions
        } else {
          updatePermissionParentFolder(parent_folder);
        }
      }

      const total = acceptedFiles.length;
      for (let i = 0; i < total; i++) {
        const file = acceptedFiles[i];
        setUploadingFileName(file.name);
        setUploadProgress(Math.round((i / total) * 100));
        try {
          const res = await UploadFiles(
            disputeId,
            folder_id,
            file,
            viewPermissions,
            deletePermissions,
            profile?.id,
            customDisputeId
          );
          dispatch(
            postActivity(
              "uploaded a file",
              file.size,
              true,
              file.name,
              disputeId,
              viewPermissions,
              res?.data?.id
            )
          );
          notifyFileUploaded(
            profile,
            disputeId,
            file.name,
            parent_folder?.nameToShowUser || parent_folder?.name
          );
        } catch (error) {
          console.log("err", error);
          if (error?.response?.status === 400) {
            const errMsg = error?.response?.data?.error || error?.response?.data?.message || "Failed to upload file.";
            showSnackbar(errMsg, "error");
          }
        }
        setUploadProgress(Math.round(((i + 1) / total) * 100));
      }
      handleCloseModalRefresh();
    } catch (error) {
      console.log("err", error);
      setLoading(false);
    }
  };

  const tabs = [
    {
      id: "details",
      label: "Details",
    },
    ...(!isHidePermissionsFeature ? [{
      id: 'permissions',
      label: 'Permissions',
    }] : [])
  ];

  const selectTab = (tab) => {
    setChoice(tab);
  };

  const body = (
    <Box className={classes.paper}>
      <Typography className={classes.firstText}>Add file</Typography>
      <Box height="1rem" />
      {/* <Grid container>
        <Grid
          item
          className={
            choice === "details" ? classes.selected : classes.unselected
          }
          onClick={() => {
            if (choice !== "details") setChoice("details");
          }}
        >
          <Typography className={classes.choiceText}>Details</Typography>
        </Grid>
        <Grid
          item
          className={
            choice === "permissions" ? classes.selected : classes.unselected
          }
          onClick={() => {
            if (choice !== "permissions") setChoice("permissions");
          }}
        >
          <Typography className={classes.choiceText}>Permissions</Typography>
        </Grid>
      </Grid> */}
      <Tabs tabs={tabs} handleClickTab={selectTab} choice={choice} />
      {choice === "details" ? (
        <>
          <Box height="1rem" />
          <Grid container className={classes.container} spacing={2}>
            <Grid item sm={3} xs={4}>
              <Typography className={classes.fieldsText}>
                Browse file
              </Typography>
            </Grid>
            <Grid item sm={9} xs={8}>
              <Box>
                <div
                  {...getRootProps({
                    className: `dropzone ${classes.dropboxSebi}`,
                  })}
                >
                  <input {...getInputProps()} type="file" />
                  {!filesPreview ? (
                    <>
                      <img src={plusImage} alt="add" />
                    </>
                  ) : (
                    acceptedFiles.map((file) => {
                      return (
                        <Typography
                          key={file.name}
                          style={{ wordBreak: "break-all" }}
                        >
                          {file.name}
                        </Typography>
                      );
                    })
                  )}
                </div>
              </Box>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Box height="1rem" />
          <Grid container className={classes.container} justify="center">
            <Box
              style={{
                background: "#F2F2F2",
                width: "100%",
                border: "1px solid #E0E0E0",
              }}
            >
              <Box
                style={{
                  textAlign: "center",
                }}
                className={classes.box}
              >
                <Typography className={classes.permissionsTable}>
                  Permissions
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid container className={classes.container} justify="center">
            <Grid container style={{ width: "100%" }}>
              <Grid
                item
                xl={5}
                lg={5}
                md={5}
                sm={5}
                xs={5}
                style={{
                  height: "-webkit-fill-available",
                  borderBottom: "1px solid #E0E0E0",
                  borderLeft: "1px solid #E0E0E0",
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                <Box
                  style={{
                    background: "#F2F2F2",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <Box className={classes.box}>
                    <Typography className={classes.permissionsTable}>
                      Name
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xl={3}
                lg={3}
                md={3}
                sm={3}
                xs={3}
                style={{
                  height: "-webkit-fill-available",
                  borderBottom: "1px solid #E0E0E0",
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                <Box
                  style={{
                    background: "#F2F2F2",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <Box className={classes.box}>
                    <Typography className={classes.permissionsTable}>
                      Profile type
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xl={2}
                lg={2}
                md={2}
                sm={2}
                xs={2}
                style={{
                  height: "-webkit-fill-available",
                  borderBottom: "1px solid #E0E0E0",
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                <Box
                  style={{
                    background: "#F2F2F2",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <Box
                    style={{
                      textAlign: "center",
                    }}
                    className={classes.box}
                  >
                    <Typography className={classes.permissionsTable}>
                      View
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xl={2}
                lg={2}
                md={2}
                sm={2}
                xs={2}
                style={{
                  height: "-webkit-fill-available",
                  borderBottom: "1px solid #E0E0E0",
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                <Box
                  style={{
                    background: "#F2F2F2",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <Box
                    style={{
                      textAlign: "center",
                    }}
                    className={classes.box}
                  >
                    <Typography className={classes.permissionsTable}>
                      Delete
                    </Typography>
                  </Box>
                </Box>
              </Grid>

            </Grid>
          </Grid>
          <Box className={classes.scroll}>
            {allProfiles.map((item) => {
              let checkedView = "";
              if (viewPermissions?.indexOf(item.user.id) !== -1) {
                checkedView = true;
              } else {
                checkedView = false;
              }
              const handleViewCheckbox = (e) => {
                checkedView = e.target.checked;
                if (e.target.checked) {
                  let arr = [...viewPermissions];
                  arr.push(item.user.id);
                  setViewPermissions(arr);
                } else {
                  let arr = [...viewPermissions];
                  let index = arr.indexOf(item.user.id);
                  if (index > -1) {
                    arr.splice(index, 1);
                    setViewPermissions(arr);
                    checkedEdit = false;
                    arr = [...deletePermissions];
                    let indexEdit = arr.indexOf(item.user.id);
                    if (indexEdit > -1) {
                      arr.splice(indexEdit, 1);
                      setdeletePermissions(arr);
                    }
                  }
                }
              };
              let checkedEdit = "";
              if (deletePermissions?.indexOf(item.user.id) !== -1) {
                checkedEdit = true;
              } else {
                checkedEdit = false;
              }
              const handleEditCheckbox = (e) => {
                checkedEdit = e.target.checked;
                if (e.target.checked) {
                  let arr = [...deletePermissions];
                  arr.push(item.user.id);
                  setdeletePermissions(arr);
                  if (viewPermissions?.indexOf(item.user.id) === -1) {
                    arr = [...viewPermissions];
                    arr.push(item.user.id);
                    setViewPermissions(arr);
                    checkedView = true;
                  }
                } else {
                  let arr = [...deletePermissions];
                  const index = arr.indexOf(item.user.id);
                  if (index > -1) {
                    arr.splice(index, 1);
                    setdeletePermissions(arr);
                  }
                }
              };
              return (
                <Grid
                  container
                  className={classes.container}
                  justify="center"
                  key={item.user.id}
                >
                  <Grid container>
                    <Grid
                      item
                      xl={5}
                      lg={5}
                      md={5}
                      sm={5}
                      xs={5}
                      style={{
                        height: "-webkit-fill-available",
                        borderBottom: "1px solid #E0E0E0",
                        borderLeft: "1px solid #E0E0E0",
                        borderRight: "1px solid #E0E0E0",
                      }}
                    >
                      <Box
                        style={{
                          background: "#F2F2F2",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <Box className={classes.box}>
                          <Typography className={classes.permissionsTableRows}>
                            {item.user.first_name} {item.user.last_name}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xl={3}
                      lg={3}
                      md={3}
                      sm={3}
                      xs={3}
                      style={{
                        height: "-webkit-fill-available",
                        borderBottom: "1px solid #E0E0E0",
                        borderRight: "1px solid #E0E0E0",
                      }}
                    >
                      <Box
                        style={{
                          background: "#F2F2F2",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <Box className={classes.box}>
                          <Typography className={classes.permissionsTableRows}>
                            {item.profile.profile_type}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xl={2}
                      lg={2}
                      md={2}
                      sm={2}
                      xs={2}
                      style={{
                        height: "-webkit-fill-available",
                        borderBottom: "1px solid #E0E0E0",
                        borderRight: "1px solid #E0E0E0",
                      }}
                    >
                      <Box
                        style={{
                          background: "#F2F2F2",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <Box
                          style={{
                            textAlign: "center",
                          }}
                          className={classes.box}
                        >
                          <input
                            type="checkbox"
                            checked={checkedView}
                            onChange={handleViewCheckbox}
                          />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xl={2}
                      lg={2}
                      md={2}
                      sm={2}
                      xs={2}
                      style={{
                        height: "-webkit-fill-available",
                        borderBottom: "1px solid #E0E0E0",
                        borderRight: "1px solid #E0E0E0",
                      }}
                    >
                      <Box
                        style={{
                          background: "#F2F2F2",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <Box
                          style={{
                            textAlign: "center",
                          }}
                          className={classes.box}
                        >
                          <input
                            type="checkbox"
                            checked={checkedEdit}
                            onChange={handleEditCheckbox}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
          </Box>
        </>
      )}
      {loading && (
        <Box style={{ marginTop: "1rem", marginBottom: "0.5rem" }}>
          <LinearProgress
            variant={uploadProgress > 0 ? "determinate" : "indeterminate"}
            value={uploadProgress}
            style={{ height: "0.5rem", borderRadius: "0.25rem" }}
          />
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "0.5rem",
            }}
          >
            <Typography
              variant="body2"
              color="textPrimary"
              style={{
                fontSize: "0.875rem",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "80%",
              }}
            >
              Uploading: {uploadingFileName || "Please wait..."}
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              style={{
                fontSize: "0.875rem",
                fontWeight: 600,
              }}
            >
              {uploadProgress}%
            </Typography>
          </Box>
        </Box>
      )}
      <Box height="1rem" />
      <Grid
        container
        justify="flex-end"
        className={classes.container}
        spacing={2}
      >
        <Grid item>
          <Button
            color="black"
            variant="outlined"
            onClick={handleCloseModal}
            disabled={loading}
            style={{ border: "1px solid" }}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button
            color="primary"
            variant="contained"
            onClick={
              (choice === 'details' && !isHidePermissionsFeature)
                ? () => setChoice("permissions")
                : handleUploadFile
            }
            disabled={acceptedFiles.length === 0 || loading}
          >
            {(choice === 'details' && !isHidePermissionsFeature) ? "Next" : "Add"}
          </Button>
        </Grid>
      </Grid>
      <Box height="1rem" />
    </Box>
  );

  return (
    <Modal
      open={openmodal}
      onClose={loading ? () => {} : handleCloseModal}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      disableEnforceFocus
    >
      <Fade in={openmodal}>{body}</Fade>
    </Modal>
  );
}
